import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import Section from "../../../components/ui/Section.jsx";
import TeamMemberCard from "../../../components/ui/TeamMemberCard.jsx";
import { teamMembers } from "../assets";

// First component unlinked from `material-kit-pro-react`: built from our own
// brand-themed UI primitives + MUI v3 Grid, driven by the teamMembers data.
const styles = {
  grid: {
    maxWidth: "1140px",
    margin: "0 auto"
  }
};

function SectionTeam({ classes }) {
  return (
    <Section title="Nuestro Equipo">
      <Grid container spacing={32} justify="center" className={classes.grid}>
        {teamMembers.map(member => (
          <Grid item xs={12} sm={6} md={3} key={member.name}>
            <TeamMemberCard
              photo={member.photo}
              name={member.name}
              role={member.role}
            />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}

SectionTeam.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SectionTeam);



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/Sections/SectionTeam.jsx